import type { LabelValue } from "newui/types/LabelValue.type";

// Reusable Enum
// NOTE: we explicitly do not use 'Client = 1' as we don't display this in companies search
export enum CompanyTypeEnum {
	HeadContractor = 2,
	Subcontractor = 3,
	Consultant = 4,
}

// Then a strongly typed array of options:
export const COMPANY_TYPE_OPTIONS: LabelValue<number>[] = [
	{ label: "Head Contractor", value: CompanyTypeEnum.HeadContractor },
	{ label: "Subcontractor", value: CompanyTypeEnum.Subcontractor },
	{ label: "Consultant", value: CompanyTypeEnum.Consultant },
];
